// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settingsProfile_pAssc {

}

.seeHistoryContainer_JY2lB {
  position: fixed;
  z-index: 9999;
}

.profile_zjwbw {
  display: flex;
  align-items: center;
  gap: 10px;
  position: sticky;
  top: -10px;
  padding-top: 0;
  background-color: var(--white-color);
  height: 100%;
  z-index: 99;
  border-bottom: 1px solid var(--eb-border);
  padding-bottom: 10px;
  margin-bottom: 20px;
  p {
    color: var(--black-color);
    margin: 0;
    font-weight: 500;
    font-size: 18px;
  }

  span {
    margin: 4px 0;
    font-size: 14px;
  }


  .profileImage_i3byx {
    width: 57px;
    height: 57px;
    border-radius: 50%;
  }


}



.form_pekaJ {
  .row_vl67X {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    p,span {
      margin: 5px 0;
      color: var(--black-color) !important;
      margin: 0;
      font-weight: 500;
      font-size: 18px;
    }
  }
  .button_ROV_B,
  .facturacionButtonEdit_VCmZB {
    text-decoration: underline;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    font-size: 14px;
    font-weight: 600;
    color: var(--_2-color);
    opacity: 0;
  }

  label:hover,
  .label_Pbm65:hover {
    .button_ROV_B,
    .editButton_MHdjl {
      opacity: 1;
    }
  }
  .phoneContainer_SrI9y {
    display: flex;
    gap: 10px;
  }

  p {
    color: var(--black-color);
    font-weight: 500;
    margin: 0;
  }
  .plan_nmGtz {
    padding-right: 30px;
    span {
      color: var(--black-color);
    }
  }

  .taxes_dUEpN {
    font-weight: 300;
    color: var(--black-color);
  }

  label {
    display: flex;
    flex-direction: column;
    color: var(--_71-color);
    gap: 5px;
    border-bottom: 1px solid var(--eb-border);
    padding-bottom: 10px; 
    input,
    select,
    option {
      padding: 8px;
      border: none;
      outline: none;
      border-radius: 6px;
      -webkit-border-radius: 6px;
      -moz-border-radius: 6px;
      -ms-border-radius: 6px;
      -o-border-radius: 6px;
      
    }

    input:disabled,
    select:disabled,
    option:disabled {
      background-color: transparent;
    }

    select,
    option {
      color: var(--_75-color);
    }
    .error_UUqBq {
      color: var(--b40e1b-color);
    }
    input:disabled,
    select:disabled,
    option:disabled,
    input[readonly],
    select[readonly],
    option[readonly],
    input::placeholder,
    select::placeholder {
      color: var(--_75-color); 
    }

    input,
    select,
    option {
      color: var(--_75-color); 
    }
  }

  .inputWrapper_p81yl {
    position: relative;
    width: 100%;
  }

  .input_nzt0B {
    width: 100%;
    padding-right: 70px;
    padding-left: 10px;
    height: 40px;
    box-sizing: border-box;
    border-radius: 4px;
  }

  .verify_rcGgG {
    position: absolute;
    right: 10px;
    top: 50%;
    font-size: 14px;
    color: var(--black-color);
    cursor: pointer;
  }

  .verify_rcGgG:hover {
    text-decoration: underline;
  }

  .numberInput_ur8i_ {
    flex-grow: 1; 
    border-radius: 4px;
    box-sizing: border-box;
    max-height: 31px;
  }

  .error_UUqBq {
    color: var(--b40e1b-color);
    font-size: 12px;
  }
  input[type="radio"] {
    box-sizing: border-box;
    appearance: none;
    width: 18px;
    height: 18px;
    border: 4px solid var(--grayAccountSettings-border);
    border-radius: 50%;
    background-color: var(--f9-background);
    cursor: pointer;
    transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    padding: 5px;
  }
  input[type="radio"]:checked {
    border-color: var(--b40e1b-color);
    background-color: var(--white-color);
    border: 4px solid var(--black-color);
  }
  .payContainer_nOtC3 {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .paymentMethod_KNTwt {
    display: flex;
    gap: 20px;
    align-items: center;
    .paymentContainer_iyWBq {
      display: flex;
      gap: 4px;
    }

    .paymentImage_dp1gu {
      background-color: var(--white-color);
      border: 1px solid var(--e2-background);
      height: 20px;
      width: 48px;
      object-fit: contain;
      padding: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 3px;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      -ms-border-radius: 3px;
      -o-border-radius: 3px;
    }
  }

  .inputContainer_hmnBY {
    position: relative;
    display: flex;
    margin-top: 8px;
    align-items: center;
  }

  .input_nzt0B {
    width: 100%;
    max-height: 31px;
    padding-right: 40px; 
    box-sizing: border-box; 
  }

  .icon_u_EfU {
    position: absolute;
    right: 10px; 
    top: 50%;
    transform: translateY(-50%);
    width: 30px; 
    height: 20px;
    pointer-events: none; 
  }



  .save_YgxSR {
    width: 100%;
    background-color: var(--_233f39-color);
    padding: 0 8px;
    color: var(--white-color);
    text-decoration: none;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    height: 50px;
    transition: background-color 0.3s ease;
    border-radius: 8px;
    &:hover {
      background-color: var(--196353-background);
    }
  }

  .facturacion_wAfDj {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 5px;
  }
  .facturacion_wAfDj:hover {
    .facturacionButtonEdit_VCmZB {
      opacity: 1;
    }
  }

  .btnContainer_vqMXy {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .fact_p25M8 {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 10px;
  }
  .factContainer_G4vZw {
    .factHeader_Fr1V4 {
      display: flex;
      gap: 10px;
      align-items: center;
    }
    p {
      margin: 0 auto;
      display: flex;
      gap: 5px;
      flex-wrap: wrap;
      align-items: center;
      color: var(--27272a-color);
      font-weight: 300;
      span {
        text-transform: capitalize;
      }
    }
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .info_BqQ7l {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 20px;
  }

  .logoCorporativo_jFvT1 {
    display: flex;
    align-items: center;
    margin-top: 15px;
    .container_YIIMz {
      display: flex;
      align-items: center;
      position: relative;
      img {
        width: 80px;
        height: 80px;
      }

      .delete_z0RCq {
        position: absolute;
        height: 20px;
        width: 20px;
        top: -7px;
        right: -7px;
        background-color: var(--dc3545-background);
        border-radius: 50%;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        -ms-border-radius: 50%;
        -o-border-radius: 50%;
        font-size: 20px;
        color: var(--white-color);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }

 
}

.editButton_MHdjl {
  text-decoration: underline;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-size: 14px;
  font-weight: 600;
  color: var(--_2-color);
  opacity: 0;
}

.initials_yFNVn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 57px;
  height: 57px;
  border-radius: 50%;
  background-color: var(--_16c09821-background);
  color: var(--white-color);
  font-size: 22px;
  font-weight: 600;
}


@media (width <= 658px) {
  .form_pekaJ {
    .button_ROV_B,
    .facturacionButtonEdit_VCmZB,
    .editButton_MHdjl {
      opacity: 1;
    }
  }
}

.noPadding_1Ve_z{
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/AccountSettings/AccountSettings.module.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,yCAAyC;EACzC,oBAAoB;EACpB,mBAAmB;EACnB;IACE,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;;EAGA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;;AAGF;;;;AAIA;EACE;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB;MACE,aAAa;MACb,oCAAoC;MACpC,SAAS;MACT,gBAAgB;MAChB,eAAe;IACjB;EACF;EACA;;IAEE,0BAA0B;IAC1B,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,UAAU;EACZ;;EAEA;;IAEE;;MAEE,UAAU;IACZ;EACF;EACA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,mBAAmB;IACnB;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,yCAAyC;IACzC,oBAAoB;IACpB;;;MAGE,YAAY;MACZ,YAAY;MACZ,aAAa;MACb,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;;IAEvB;;IAEA;;;MAGE,6BAA6B;IAC/B;;IAEA;;MAEE,uBAAuB;IACzB;IACA;MACE,0BAA0B;IAC5B;IACA;;;;;;;;MAQE,uBAAuB;IACzB;;IAEA;;;MAGE,uBAAuB;IACzB;EACF;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,eAAe;IACf,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mDAAmD;IACnD,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;IACf,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,YAAY;EACd;EACA;IACE,iCAAiC;IACjC,oCAAoC;IACpC,oCAAoC;EACtC;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB;MACE,aAAa;MACb,QAAQ;IACV;;IAEA;MACE,oCAAoC;MACpC,sCAAsC;MACtC,YAAY;MACZ,WAAW;MACX,mBAAmB;MACnB,YAAY;MACZ,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;IACvB;EACF;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,oBAAoB;EACtB;;;;EAIA;IACE,WAAW;IACX,sCAAsC;IACtC,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,YAAY;IACZ,sCAAsC;IACtC,kBAAkB;IAClB;MACE,0CAA0C;IAC5C;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;EACA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;EACA;IACE;MACE,aAAa;MACb,SAAS;MACT,mBAAmB;IACrB;IACA;MACE,cAAc;MACd,aAAa;MACb,QAAQ;MACR,eAAe;MACf,mBAAmB;MACnB,0BAA0B;MAC1B,gBAAgB;MAChB;QACE,0BAA0B;MAC5B;IACF;IACA,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB;MACE,aAAa;MACb,mBAAmB;MACnB,kBAAkB;MAClB;QACE,WAAW;QACX,YAAY;MACd;;MAEA;QACE,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,SAAS;QACT,WAAW;QACX,0CAA0C;QAC1C,kBAAkB;QAClB,0BAA0B;QAC1B,uBAAuB;QACvB,sBAAsB;QACtB,qBAAqB;QACrB,eAAe;QACf,yBAAyB;QACzB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;MACjB;IACF;EACF;;;AAGF;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE;IACE;;;MAGE,UAAU;IACZ;EACF;AACF;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".settingsProfile {\n\n}\n\n.seeHistoryContainer {\n  position: fixed;\n  z-index: 9999;\n}\n\n.profile {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  position: sticky;\n  top: -10px;\n  padding-top: 0;\n  background-color: var(--white-color);\n  height: 100%;\n  z-index: 99;\n  border-bottom: 1px solid var(--eb-border);\n  padding-bottom: 10px;\n  margin-bottom: 20px;\n  p {\n    color: var(--black-color);\n    margin: 0;\n    font-weight: 500;\n    font-size: 18px;\n  }\n\n  span {\n    margin: 4px 0;\n    font-size: 14px;\n  }\n\n\n  .profileImage {\n    width: 57px;\n    height: 57px;\n    border-radius: 50%;\n  }\n\n\n}\n\n\n\n.form {\n  .row {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    p,span {\n      margin: 5px 0;\n      color: var(--black-color) !important;\n      margin: 0;\n      font-weight: 500;\n      font-size: 18px;\n    }\n  }\n  .button,\n  .facturacionButtonEdit {\n    text-decoration: underline;\n    cursor: pointer;\n    -webkit-user-select: none;\n    user-select: none;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--_2-color);\n    opacity: 0;\n  }\n\n  label:hover,\n  .label:hover {\n    .button,\n    .editButton {\n      opacity: 1;\n    }\n  }\n  .phoneContainer {\n    display: flex;\n    gap: 10px;\n  }\n\n  p {\n    color: var(--black-color);\n    font-weight: 500;\n    margin: 0;\n  }\n  .plan {\n    padding-right: 30px;\n    span {\n      color: var(--black-color);\n    }\n  }\n\n  .taxes {\n    font-weight: 300;\n    color: var(--black-color);\n  }\n\n  label {\n    display: flex;\n    flex-direction: column;\n    color: var(--_71-color);\n    gap: 5px;\n    border-bottom: 1px solid var(--eb-border);\n    padding-bottom: 10px; \n    input,\n    select,\n    option {\n      padding: 8px;\n      border: none;\n      outline: none;\n      border-radius: 6px;\n      -webkit-border-radius: 6px;\n      -moz-border-radius: 6px;\n      -ms-border-radius: 6px;\n      -o-border-radius: 6px;\n      \n    }\n\n    input:disabled,\n    select:disabled,\n    option:disabled {\n      background-color: transparent;\n    }\n\n    select,\n    option {\n      color: var(--_75-color);\n    }\n    .error {\n      color: var(--b40e1b-color);\n    }\n    input:disabled,\n    select:disabled,\n    option:disabled,\n    input[readonly],\n    select[readonly],\n    option[readonly],\n    input::placeholder,\n    select::placeholder {\n      color: var(--_75-color); \n    }\n\n    input,\n    select,\n    option {\n      color: var(--_75-color); \n    }\n  }\n\n  .inputWrapper {\n    position: relative;\n    width: 100%;\n  }\n\n  .input {\n    width: 100%;\n    padding-right: 70px;\n    padding-left: 10px;\n    height: 40px;\n    box-sizing: border-box;\n    border-radius: 4px;\n  }\n\n  .verify {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    font-size: 14px;\n    color: var(--black-color);\n    cursor: pointer;\n  }\n\n  .verify:hover {\n    text-decoration: underline;\n  }\n\n  .numberInput {\n    flex-grow: 1; \n    border-radius: 4px;\n    box-sizing: border-box;\n    max-height: 31px;\n  }\n\n  .error {\n    color: var(--b40e1b-color);\n    font-size: 12px;\n  }\n  input[type=\"radio\"] {\n    box-sizing: border-box;\n    appearance: none;\n    width: 18px;\n    height: 18px;\n    border: 4px solid var(--grayAccountSettings-border);\n    border-radius: 50%;\n    background-color: var(--f9-background);\n    cursor: pointer;\n    transition: all 0.3s ease;\n    -webkit-transition: all 0.3s ease;\n    -moz-transition: all 0.3s ease;\n    -ms-transition: all 0.3s ease;\n    -o-transition: all 0.3s ease;\n    padding: 5px;\n  }\n  input[type=\"radio\"]:checked {\n    border-color: var(--b40e1b-color);\n    background-color: var(--white-color);\n    border: 4px solid var(--black-color);\n  }\n  .payContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  .paymentMethod {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n    .paymentContainer {\n      display: flex;\n      gap: 4px;\n    }\n\n    .paymentImage {\n      background-color: var(--white-color);\n      border: 1px solid var(--e2-background);\n      height: 20px;\n      width: 48px;\n      object-fit: contain;\n      padding: 5px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border-radius: 3px;\n      -webkit-border-radius: 3px;\n      -moz-border-radius: 3px;\n      -ms-border-radius: 3px;\n      -o-border-radius: 3px;\n    }\n  }\n\n  .inputContainer {\n    position: relative;\n    display: flex;\n    margin-top: 8px;\n    align-items: center;\n  }\n\n  .input {\n    width: 100%;\n    max-height: 31px;\n    padding-right: 40px; \n    box-sizing: border-box; \n  }\n\n  .icon {\n    position: absolute;\n    right: 10px; \n    top: 50%;\n    transform: translateY(-50%);\n    width: 30px; \n    height: 20px;\n    pointer-events: none; \n  }\n\n\n\n  .save {\n    width: 100%;\n    background-color: var(--_233f39-color);\n    padding: 0 8px;\n    color: var(--white-color);\n    text-decoration: none;\n    cursor: pointer;\n    user-select: none;\n    height: 50px;\n    transition: background-color 0.3s ease;\n    border-radius: 8px;\n    &:hover {\n      background-color: var(--196353-background);\n    }\n  }\n\n  .facturacion {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-top: 5px;\n  }\n  .facturacion:hover {\n    .facturacionButtonEdit {\n      opacity: 1;\n    }\n  }\n\n  .btnContainer {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  .fact {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    margin-top: 10px;\n  }\n  .factContainer {\n    .factHeader {\n      display: flex;\n      gap: 10px;\n      align-items: center;\n    }\n    p {\n      margin: 0 auto;\n      display: flex;\n      gap: 5px;\n      flex-wrap: wrap;\n      align-items: center;\n      color: var(--27272a-color);\n      font-weight: 300;\n      span {\n        text-transform: capitalize;\n      }\n    }\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  .info {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    margin-bottom: 20px;\n  }\n\n  .logoCorporativo {\n    display: flex;\n    align-items: center;\n    margin-top: 15px;\n    .container {\n      display: flex;\n      align-items: center;\n      position: relative;\n      img {\n        width: 80px;\n        height: 80px;\n      }\n\n      .delete {\n        position: absolute;\n        height: 20px;\n        width: 20px;\n        top: -7px;\n        right: -7px;\n        background-color: var(--dc3545-background);\n        border-radius: 50%;\n        -webkit-border-radius: 50%;\n        -moz-border-radius: 50%;\n        -ms-border-radius: 50%;\n        -o-border-radius: 50%;\n        font-size: 20px;\n        color: var(--white-color);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n      }\n    }\n  }\n\n \n}\n\n.editButton {\n  text-decoration: underline;\n  cursor: pointer;\n  user-select: none;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--_2-color);\n  opacity: 0;\n}\n\n.initials {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 57px;\n  height: 57px;\n  border-radius: 50%;\n  background-color: var(--_16c09821-background);\n  color: var(--white-color);\n  font-size: 22px;\n  font-weight: 600;\n}\n\n\n@media (width <= 658px) {\n  .form {\n    .button,\n    .facturacionButtonEdit,\n    .editButton {\n      opacity: 1;\n    }\n  }\n}\n\n.noPadding{\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settingsProfile": `settingsProfile_pAssc`,
	"seeHistoryContainer": `seeHistoryContainer_JY2lB`,
	"profile": `profile_zjwbw`,
	"profileImage": `profileImage_i3byx`,
	"form": `form_pekaJ`,
	"row": `row_vl67X`,
	"button": `button_ROV_B`,
	"facturacionButtonEdit": `facturacionButtonEdit_VCmZB`,
	"label": `label_Pbm65`,
	"editButton": `editButton_MHdjl`,
	"phoneContainer": `phoneContainer_SrI9y`,
	"plan": `plan_nmGtz`,
	"taxes": `taxes_dUEpN`,
	"error": `error_UUqBq`,
	"inputWrapper": `inputWrapper_p81yl`,
	"input": `input_nzt0B`,
	"verify": `verify_rcGgG`,
	"numberInput": `numberInput_ur8i_`,
	"payContainer": `payContainer_nOtC3`,
	"paymentMethod": `paymentMethod_KNTwt`,
	"paymentContainer": `paymentContainer_iyWBq`,
	"paymentImage": `paymentImage_dp1gu`,
	"inputContainer": `inputContainer_hmnBY`,
	"icon": `icon_u_EfU`,
	"save": `save_YgxSR`,
	"facturacion": `facturacion_wAfDj`,
	"btnContainer": `btnContainer_vqMXy`,
	"fact": `fact_p25M8`,
	"factContainer": `factContainer_G4vZw`,
	"factHeader": `factHeader_Fr1V4`,
	"info": `info_BqQ7l`,
	"logoCorporativo": `logoCorporativo_jFvT1`,
	"container": `container_YIIMz`,
	"delete": `delete_z0RCq`,
	"initials": `initials_yFNVn`,
	"noPadding": `noPadding_1Ve_z`
};
export default ___CSS_LOADER_EXPORT___;
